import { render, staticRenderFns } from "./RuleSetup.vue?vue&type=template&id=3bb152bc&scoped=true&"
import script from "./RuleSetup.vue?vue&type=script&lang=ts&"
export * from "./RuleSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb152bc",
  null
  
)

export default component.exports